export const shadows = {
    none: 'none',
    medium: '0px 4px 4px 0px rgba(24, 36, 71, 0.16), 0px 8px 16px 0px rgba(17, 25, 40, 0.16)',
} satisfies Record<string, string>
